<template>
  <ai-carousel-overflow-item
    :title="subtitle"
    :description="description"
    :picture="picture"
    :detail-link="detailLink"
    :cta-label="ctaLabel"
    :aria-label="
      $t('accessibility.description.hotelOffersAndPackagesItem', {
        itemTitle: title,
      })
    "
    :card-as-link="true"
    title-variant-typo="paragraph-04-bold"
    margin="inner-01"
    lazy-load-picture>
    <template #top>
      <ai-typo
        class="HotelOffersAndPackagesCarouselItem-subtitle"
        as="p"
        variant="heading-04"
        color="white">
        {{ title }}
      </ai-typo>
    </template>
  </ai-carousel-overflow-item>
</template>

<script setup lang="ts">
import type { AiPicture } from '~~/domains/graphql';

interface Props {
  title: string;
  subtitle: string;
  description: string;
  ctaLabel?: string;
  detailLink?: string;
  picture?: AiPicture;
}

defineProps<Props>();
</script>

<style scoped lang="scss">
@use '@/assets/styles/utilities/constants';

.HotelOffersAndPackagesCarouselItem-subtitle {
  margin-bottom: constants.$margin-01;
}
</style>
